import * as Yup from 'yup';

export function getAuthInitialValues(obj) {
  if (obj.isChecked) {
    obj.isChecked = true
  }
  let emailValue = obj.email || ''
  let isGuestRegisteredUser = localStorage.getItem('guestRegisteredUserEmail')
  if(isGuestRegisteredUser) emailValue = isGuestRegisteredUser?.trim()
  localStorage.removeItem('guestRegisteredUserEmail')
  return {
    email: emailValue,
    password: obj.password || '',
    rememberMe: obj.isChecked || false,
  }
}
const VALIDATION_SCHEMA = (pageLanguageContents) => {
  let schemaAttributes
    schemaAttributes = {
      email: Yup.string().email(pageLanguageContents?.Error_Validations[0]?.Valid_Email).required(pageLanguageContents?.Error_Validations[1]?.Email_Req)
      // .matches(/^[a-zA-Z0-9_!#$%&amp;'*+/=?`{|}~^.-]+@[a-zA-Z0-9-]+(.com|.net|.co.in|.org|.int.edu|.gov|mil|.int|.edu|.cc|.co.uk|us){1}$/,pageLanguageContents?.Error_Validations[0]?.Valid_Email)
      ,
      password: Yup.string()
        .label('Password')
        .required(pageLanguageContents?.Error_Validations[2]?.Pass_Req).nullable()
        .matches(/[a-z]+/, "Password isn't secure.")
        .matches(/[A-Z]+/, "Password isn't secure.")
        .matches(/[@$!%*#?&]+/, "Password isn't secure.")
        .matches(/\d+/, "Password isn't secure.")
        .min(8, "Password should be more than 8 characters.")
        .max(20, pageLanguageContents?.Error_Validations[4]?.Max_Twenty)
    };
  return Yup.object().shape(schemaAttributes);
}

export { VALIDATION_SCHEMA };
